module.exports = __webpack_public_path__ + "static/img/emoji_147.094cf71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emoji/emoji_147.png
// module id = 9SBs
// module chunks = 6